<template>
    <div>
        <div class="action-table-web" v-if="$detect == 'web'">
            <div class="row">
                <div class="col-2">
                    <button class="btn btn-primary btn-sm btn-block" :disabled="idSelect.length == 0 || loading"
                        @click="sale()">Khuyến mại</button>
                </div>
                <div class="col-3">
                    <div class="row">
                        <div class="col-12">
                            <ldc-select
                                placeholder="Trạng thái"
                                v-model="data.status"
                                @change="getExp()">
                                <ldc-option
                                    v-for="(data, index) in arrPromotionStatus" :key="index"
                                    :value="index"
                                    :label="data"/>
                            </ldc-select>
                        </div>
                    </div>
                </div>
                <div class="col-7">
                    <div class="row">
                        <div class="col-9">
                            <div class="search position-relative">
                                <input type="text" class="w-100 bg-white fs-14px"
                                placeholder="Nhập #id hoặc tiêu đề tin"
                                @keyup.enter="enterKeyword()" v-model="data.keyword"/>
                                <div class="btn-search position-absolute" @click="enterKeyword()">
                                    <span class="lable-search px-10px">
                                        <i class="icon ion-ios-search fs-20px"></i>
                                    </span>
                                </div>
                                <div class="text-warning-search fs-10px position-absolute">
                                    * Ghi # để tìm kiếm theo id ( vd: <i>#123456</i> )
                                </div>
                            </div>
                        </div>
                        <div class="col-3">
                            <button class="btn btn-block border-0 fs-14px btn-cancel-filter" style="height: 35px;" @click="removeFillter()">Bỏ lọc</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="action-table-mobile">
                <div input-search>
                    <div content-input-search class="search-box position-relative">
                        <input type="text" placeholder="Nhập id hoặc tiêu đề tin" v-model="data.keyword" @keyup.enter="enterKeyword()"/>
                        <div class="text-warning-search fs-10px"> * Ghi # để tìm kiếm theo id ( vd: <i>#123456</i> ) </div>
                    </div>
                </div>
                <div class="d-flex mb-10px">
                    <div class="w-50 pr-1">
                        <button type="button" class="btn btn-primary btn-action-check btn-block fs-14px px-1" :disabled="idSelect.length == 0 || loading"
                            @click="sale()">
                            Khuyến mại
                        </button>
                    </div>
                    <div class="w-50 pl-1">
                        <button type="button" class="btn btn-primary time-date btn-block bg-white fs-14px pl-10px"
                            @click="fillterMobile = true">
                            <i class="icon ion-ios-options fs-18px mr-2"></i>Lọc nâng cao
                        </button>
                    </div>
                </div>
            </div>
            <ldc-model-mobile
                titileCancel="Hủy"
                :showCancel="false"
                :showTitle="true"
                title="Lọc tin rao"
                :customButton="true"
                :visible.sync="fillterMobile">
                <div slot="content-model"
                    :class="{
                        'fillter-android': $isAndroid,
                        'fillter-ios': !$isAndroid,
                    }">
                    <div class="item-fillter" role="button">
                        <ldc-select-mobile
                            placeholder="Trạng thái"
                            title="Loại tin"
                            v-model="data.status"
                            @change="getExp()">
                            <ldc-option-mobile
                                v-for="(data, index) in arrPromotionStatus" :key="index"
                                :value="index"
                                :label="data"/>
                        </ldc-select-mobile>
                    </div>
                </div>
                <div slot="custom-buttom"
                    :class="{
                        'fillter-android': $isAndroid,
                        'fillter-ios': !$isAndroid,
                    }">
                    <div :class="{
                        'btn-confirm-android': $isAndroid,
                        'btn-confirm-ios mb-10px': !$isAndroid
                        }">
                        <button class="btn btn-primary radius-ios text-uppercase mr-10px fs-14px btn-apply"
                            @click="emitModel()" close-model-mobile>áp dụng</button>
                        <button class="btn btn-light radius-ios text-uppercase ml-10px fs-14px btn-cancel"
                            @click="removeFillter()" close-model-mobile>Bỏ lọc</button>
                    </div>
                </div>
            </ldc-model-mobile>
        </div>
    </div>
</template>

<script>
export default {
    props: ['value', 'idSelect','arrPromotionStatus'],
    data() {
        return {
            loading: false,
            data: {
                category: 0,
                status: 0,
                keyword: '',
            },
            fillterMobile: false,
        }
    },
    watch: {
        value: {
            handler(val){
                this.data = val;
            },
            deep: true,
        },
    },
    created(){
    },
    methods: {
        sale(){
            this.loading = true;
            let query = '';
            this.idSelect.map((item, index) => {
                if(index == 0){
                    query += item
                }else{
                    query += ','+item
                }
            })
            this.$router.push({
                name: 'product-action-product-sale',
                query: {
                    id: query
                }
            })
            //  availability(this.idSelect, this);
            this.loading = false;
            // await this.$eventBus.$emit('call-page-expire', true);
        },
        emitModel(){
            this.$emit('input', {
                category: this.data.category,
                status: this.data.status,
                keyword: this.data.keyword,
            })
        },
        enterKeyword(){
            this.emitModel();
        },
        removeFillter(){
            this.data = {
                category: 0,
                status: 0,
                keyword: '',
            };
            this.emitModel();
        },
        getExp() {
            this.data.keyword = '';
            this.emitModel();
        }
    }
}
</script>

<style lang="scss">
.ldc-model-mobile {
    .value-select-mobile {
        text-align: right;
    }
}
</style>
